import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Input, Select, Button, Table, notification } from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { SearchOutlined } from '@ant-design/icons'

import {
  getMemberAssignee,
  getPermissionAssignee,
  editPermissionAssignee,
} from 'api/Project/sprintFlow'

import { getCookie } from 'helper/cookie'
import lang from 'lang/en'
const Container = styled.div`
  background-color: ${ColorList.white};
  min-height: 500px;
  width: 100;
  // height: auto;
  margin-top: 16px;
  margin-left: 4px;
`

const initalState = {
  data: [],
  isLoading: true,
}

const AddTaskAssignee = (props) => {
  ///lang
  const language = getCookie('lang')
  const word = lang[language]
  const { swithCaseTaskFLowFunction, role, idEditPRJ } = props
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  const [dataMember, setDataMember] = useState(initalState.data)
  const [dataPermission, setDataPermission] = useState(initalState.data)
  const [SearchTerm, setSearchTerm] = useState('')

  const [disabledSave, setDisabledSave] = useState(false)

  const [form] = Form.useForm()

  // const handleEditPermissionAssignee = (item) => {
  //   const dataArray = {
  //     project_id: parseInt(idEditPRJ),
  //     sprintflow_id: props.idsubtask,
  //     account_id: item.account_id,
  //     permission: 5,
  //   }
  //   try {
  //     editPermissionAssignee({
  //       params: dataArray,
  //       token: token,
  //     }).then(async (response) => {
  //       const { status, data } = response
  //       if (status == 200) {
  //         // swithCaseTaskFLowFunction('')
  //       }
  //     })
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const getMemberData = async () => {
    await getMemberAssignee({
      sprintflow_id: props.idsubtask,
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        // console.log(response)
        const { status, data, error } = response

        // console.log(data.member)
        if (error) {
          await setDataMember([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          if (data.member == null) {
            setDataMember([])
          } else {
            await setDataMember(data.member)
            data.member.map((item) => {
              if (item.permission == 0) {
                item.permission = 7
              }
              // if (item.permission == 7) {
              //   // item.permission = 5
              //   handleEditPermissionAssignee(item)
              // }
              if (item.role == 'Project Leader') {
                item.permission = 5
              }
              form.setFieldsValue({
                [item.firstname + item.role]: item.permission,
              })
            })
          }
          await setIsLoading(false)
        } else {
          setDataMember([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataMember([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getPrmissionData = async () => {
    await getPermissionAssignee({
      token: token,
    })
      .then(async (response) => {
        // console.log(response)
        const { status, data, error } = response

        if (error) {
          await setDataPermission([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setDataPermission(data)
          await setIsLoading(false)
        } else {
          setDataPermission([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataPermission([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getMemberData()
      getPrmissionData()
    }
  }, [token])

  // useEffect(() => {
  //   if (dataMember.length > 0) {
  //     const fetchData = async () => {
  //       try {
  //         await getMemberData()
  //       } catch (error) {
  //         console.error('Error fetching member data:', error)
  //       }
  //     }
  //     fetchData()
  //   }
  // }, [dataMember])

  const openNotificationWithIcon = (
    type,
    account_id,
    firstname,
    lastname,
    permission,
  ) => {
    let a = permission
    if (a == 5) {
      a = 'Assignee'
    } else {
      dataPermission.map((item) => {
        if (permission == item.id) {
          a = item.title
        }
      })
    }

    notification[type]({
      message: 'Success',
      description: firstname + ' ' + lastname + ' ' + 'has been ' + a.toLowerCase() + '.',
      duration: 3,
    })
  }
  const onChange = (e, record, notifi) => {
    // // form.setFieldsValue({
    // //   [record.firstname + record.rolename]: e,
    // })
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: props.idsubtask,
      account_id: record.account_id,
      permission: e,
    }
    // console.log(dataArray)
    try {
      editPermissionAssignee({
        params: dataArray,
        token: token,
      }).then(async (response) => {
        // console.log(response)
        const { status, data, error } = response
        // console.log(status)
        if (status == 200) {
          if (notifi == true) {
            openNotificationWithIcon(
              'success',
              record.account_id,
              record.firstname,
              record.lastname,
              e,
            )
          } else {
          }
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const dataSource = dataMember
    .filter((item) =>
      [item.firstname, item.lastname, `${item.firstname} ${item.lastname}`].some((el) =>
        el.toLowerCase().includes(SearchTerm.toLowerCase()),
      ),
    )

    .map((item) => ({
      account_id: item.account_id,
      project_id: item.project_id,
      rolename: item.role,
      permissions: dataPermission,
      permissionsmember: item.permission,
      position: item.skill,
      firstname: item.firstname,
      lastname: item.lastname,
      pic_display: item.pic_display,
    }))

  const columns = [
    {
      title: word['addtask_assignee_title_rolename'],
      dataIndex: 'rolename',
      key: 'rolename',
      // width: 250,
      ellipsis: true,
      render: (text, record) => {
        return (
          <div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <img
                className="imageStyle"
                src={record.pic_display}
                style={{ marginRight: 16 }}
              ></img>

              <div>
                <p>{text}</p>
                <small style={{ color: '#7C7C84' }}>
                  {record.firstname} {record.lastname}
                </small>
              </div>
            </div>
          </div>
        )
      },
    },
    {
      title: word['addtask_assignee_title_skills'],
      dataIndex: 'position',
      key: 'position',
      // width: 400,
      ellipsis: true,
    },
    {
      title: word['addtask_assignee_title_permission'],
      dataIndex: 'permissions',
      key: 'permissions',
      ellipsis: true,
      render: (text, record) => {
        if (record.rolename == 'Project Leader') {
          if (record.permissionsmember == 0) {
            if (role == true) {
            } else {
              onChange(5, record)
            }
          }
          return (
            <Form.Item name={record.firstname + record.rolename}>
              <p style={{ paddingLeft: 10 }}>{word['addtask_assignee_value_assignee']}</p>
            </Form.Item>
          )
        } else {
          if (role == true) {
            return (
              <div>
                <Form.Item name={record.firstname + record.rolename}>
                  <Select
                    disabled
                    className="selectionassignee"
                    placeholder="dropdown"
                    style={{ width: 120 }}
                    onChange={(e) => onChange(e, record, false)}
                  >
                    {text
                      .filter(item => item.id !== 7 || item.id === record.permissionsmember)
                      .map((item) => (
                        <Option key={item.id} value={item.id} dataselect={item} datamember={record}>
                          {item.title}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </div>
            )
          } else {
            return (
              <div>
                <Form.Item name={record.firstname + record.rolename}>
                  <Select
                    className="selectionassignee"
                    placeholder="dropdown"
                    style={{ width: 120 }}
                    onChange={(e) => onChange(e, record, true)}
                  >
                    {text
                      .filter(item => item.id !== 7 || item.id === record.permissionsmember)
                      .map((item) => (
                        <Option key={item.id} value={item.id} dataselect={item} datamember={record}>
                          {item.title}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </div>
            )
          }
        }
      },
    },
  ]

  // const onFinish = (values) => {
  //   console.log(values)

  //   dataMember.map((item) => {
  //     let formitemname = item.firstname + item.role

  //     const dataArray = {
  //       project_id: parseInt(idEditPRJ),
  //       sprintflow_id: props.idsubtask,
  //       account_id: item.account_id,
  //       permission: values[formitemname],
  //     }
  //     console.log(dataArray)
  //     try {
  //       editPermissionAssignee({
  //         params: dataArray,
  //         token: token,
  //       }).then(async (response) => {
  //         // console.log(response)
  //         const { status, data, error } = response
  //         console.log(status)
  //         if (status == 200) {
  //           props.handleOkAddTask()
  //         }
  //       })
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   })
  // }

  const onChangeSearch = (e) => {
    setSearchTerm(e.target.value)
  }
  return (
    <Container>
      <Form
        form={form}
        name="addtaskassingee"
      // onFinish={onFinish}
      >
        <Row style={{ marginTop: 32 }}>
          <Col span={16}>
            <h4 style={{ marginTop: 10 }}>{word['addtask_assignee_title_member']}</h4>
          </Col>
          <Col span={8} style={{ paddingLeft: 7 }}>
            <Input
              prefix={<SearchOutlined />}
              placeholder="Search Member"
              type="text"
              // value={SearchTerm}
              onChange={onChangeSearch}
              size="large"
              allowClear
            />
          </Col>
        </Row>

        <Table
          className="tableassignee"
          style={{ marginTop: 16 }}
          dataSource={dataSource}
          columns={columns}
          pagination={false}
        />

        <Row justify="end" style={{ marginTop: 76 }}>
          {/* <Button
            style={{
              marginRight: 7,
            }}
            className="BTN_Previous"
            onClick={() => props.setModalVisionAddTask(false)}
          >
            Cancel
          </Button> */}

          {/* <Button
            className="BTN_Next"
            htmlType="submit"
            onClick={() => setSearchTerm('')}
          >
            Save
          </Button> */}
        </Row>
      </Form>
    </Container>
  )
}
export default AddTaskAssignee
